<div class="page-header">
  <app-back-button (back)="goBack()" *ngIf="userName === 'Meraki - Operations'"></app-back-button>
  <p class="title" *ngIf="showNotificationSettings">Tenant Specific Settings</p>
  <p class="title" *ngIf="showVesselUpload && !showTechnicalFile">
    Upload Vessel Questionnaire
  </p>
  <p class="title" *ngIf="showVesselUpload && showTechnicalFile">Upload Files</p>
</div>

<div class="settings-header" *ngIf="showVesselUpload && showNotificationSettings">
  <div class="tab-item" [class.active]="selectedSetting === 'vessel'" (click)="selectedSetting = 'vessel'">
    Vessel Specific
  </div>
  <div class="tab-item" [class.active]="selectedSetting === 'alerts'" (click)="selectedSetting = 'alerts'">
    Notification Settings
  </div>
</div>

<div *ngIf="showNotificationSettings && selectedSetting === 'alerts'" class="alerts-section mb-4">
  <app-speed-threshold></app-speed-threshold>
</div>

<div class="upload-wrapper" *ngIf="showVesselUpload && selectedSetting === 'vessel'">
  <div class="upload-box">
    <h3 class="text-center mb-4 label">Upload Files</h3>

    <div class="file-section">
      <label><strong>Q88 File (.pdf)</strong></label>
      <div class="file-preview">
        {{ selectedQ88File?.name || "No file selected" }}
      </div>
      <div class="uploadIcon">
        <mat-icon class="upload-icon ml-2" (click)="q88FileInput.click()"
          matTooltip="Choose Q88 File">cloud_upload</mat-icon>
      </div>
      <input type="file" hidden #q88FileInput (change)="onQ88FileSelected($event)" accept=".pdf" />
    </div>

    <div class="file-section mt-4" *ngIf="showTechnicalFile">
      <label><strong>Technical Design File (.xlsx, .xls, .csv)</strong></label>
      <div class="file-preview">
        {{ selectedTechFile?.name || "No file selected" }}
      </div>
      <div class="uploadIcon">
        <mat-icon class="upload-icon ml-2" (click)="techFileInput.click()"
          matTooltip="Choose Technical File">cloud_upload</mat-icon>
      </div>
      <input type="file" hidden #techFileInput (change)="onTechFileSelected($event)"
        accept=".xlsx, .xls, .xlsm, .csv" />
    </div>

    <div class="file-section mt-4">
      <label><strong>Q88 Data File (.json) <span style="font-weight: normal; font-size: 13px; color: #555;">(Optional -
            skips Extractor)</span></strong></label>
      <div class="file-preview">
        {{ selectedJsonFile?.name || "No file selected" }}
      </div>
      <div class="uploadIcon d-flex align-items-center">
        <mat-icon class="upload-icon ml-2" (click)="jsonFileInput.click()"
          matTooltip="Choose Q88 JSON File">cloud_upload</mat-icon>
        <mat-icon *ngIf="selectedJsonFile" class="upload-icon ml-2 text-danger"
          style="cursor: pointer; font-size: 28px;" (click)="removeJsonFile()"
          matTooltip="Remove JSON File">close</mat-icon>
      </div>
      <input type="file" hidden #jsonFileInput (change)="onJsonFileSelected($event)" accept=".json" />
    </div>

    <div class="mt-4 text-center">
      <button class="btn btn-light hover-button mail" (click)="submitClick()">
        Submit
      </button>
    </div>
  </div>
</div>